module.exports = __webpack_public_path__ + "img/ordToning4.b809305e.jpg";